import React from 'react';
import './styles.css'
import { elastic as Menu } from "react-burger-menu";
import $ from 'jquery';

import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faBusinessTime,
    faPaintBrush,
} from "@fortawesome/free-solid-svg-icons";

export default class BurgerMenu extends React.Component{

    componentDidMount() {
        $('.menu-section').removeClass('bm-item');
    }

    render() { 
        return(
            <Menu pageWrapId={"page-wrap"} right isOpen={false} outerContainerId={"outer-container"}>
                <Link to="/">Úvodná stránka</Link>
                <h2 className="menu-section">
                    Reklama
                    <FontAwesomeIcon icon={faBusinessTime} />
                </h2>
                <Link to="/3d-napisy">3D Nápisy</Link>
                <Link to="/malovana-reklama">Maľovaná reklama</Link>
                <h2 className="menu-section">
                    Art <FontAwesomeIcon icon={faPaintBrush} />
                </h2>
                <Link to="/obrazy">
                    Obrazy
                </Link>
                <Link to="/kreslene-portrety">
                    Kreslené portréty
                </Link>
                <Link to="/airbrush">Airbrush</Link>
                <Link to="/tetovania">Tetovania</Link>
                <Link to="/foto">Foto</Link>
            </Menu>
        )
    }
}